export default __webpack_public_path__ + "static/paint-spray-f0ef55baa8d3ca6a67ab66e1e9756b60.webp";